import { CheckCircleFilled, RightOutlined } from '@ant-design/icons'
import { Button, Card, Flex, Switch, Typography } from 'antd'
import React from 'react'
import { DesignSystem } from '~/core/designSystem'
import { AppSessionType } from '~/features/appSession/common'
import { FormConfigurationType } from '~/features/formConfiguration/common'
import { Toolbox } from '~/plugins/toolbox/shared'

type Props = {
  appSession: AppSessionType
  formConfigurations: FormConfigurationType[]
  onClick: (formConfiguration: FormConfigurationType) => void
  onChange: (
    formConfiguration: FormConfigurationType,
    appSession: AppSessionType,
    status: 'submitted' | 'disabled',
  ) => void
}

export const FlowOverview: React.FC<Props> = ({
  appSession,
  formConfigurations = [],
  onClick,
  onChange,
}) => {
  const { useToken } = DesignSystem.use()
  const { token } = useToken()
  const forms = appSession?.values?.forms ?? {}

  const isFlowActive = (formConfiguration: FormConfigurationType) => {
    const status = forms[formConfiguration.key]?.['_formStatus']
    return status === 'submitted'
  }

  const isFlowDisabled = (formConfiguration: FormConfigurationType) => {
    const status = forms[formConfiguration.key]?.['_formStatus']
    return status === 'disabled'
  }

  const isFlowStarted = (formConfiguration: FormConfigurationType) => {
    return Toolbox.Utility.isDefined(forms[formConfiguration.key])
  }

  const handleClickStatus = (formConfiguration: FormConfigurationType) => {
    const formsUpdated = {
      ...forms,
      [formConfiguration.key]: {
        ...forms[formConfiguration.key],
      },
    }

    if (isFlowActive(formConfiguration)) {
      formsUpdated[formConfiguration.key]._formStatus = 'disabled'
    } else {
      formsUpdated[formConfiguration.key]._formStatus = 'submitted'
    }

    onChange(
      formConfiguration,
      {
        ...appSession,
        values: { ...appSession.values, forms: formsUpdated },
      },
      formsUpdated[formConfiguration.key].status,
    )
  }

  return (
    <>
      <Flex>
        {formConfigurations.map(formConfiguration => {
          const isStarted = isFlowStarted(formConfiguration)
          const isDisabled = isFlowDisabled(formConfiguration)
          const isActive = isFlowActive(formConfiguration)
          return (
            <Card key={formConfiguration.id} size="small">
              <Flex vertical gap={8}>
                <Flex vertical>
                  <Flex justify="space-between" align="center" gap={8}>
                    <Typography.Text strong>
                      {formConfiguration.title}{' '}
                      {isActive && (
                        <CheckCircleFilled
                          style={{ color: token.colorSuccess }}
                        />
                      )}
                    </Typography.Text>

                    {isStarted && (
                      <Switch
                        size="small"
                        checked={isActive}
                        onChange={() => handleClickStatus(formConfiguration)}
                      />
                    )}
                  </Flex>
                  <Typography.Text>
                    {formConfiguration.description}
                  </Typography.Text>
                </Flex>

                <Flex justify="space-between">
                  {isStarted ? (
                    <>
                      {isActive || isDisabled ? (
                        <Button
                          size="small"
                          // type="text"
                          icon={<RightOutlined />}
                          iconPosition="end"
                          onClick={() => onClick(formConfiguration)}
                        >
                          Edit
                        </Button>
                      ) : (
                        <Button
                          size="small"
                          type="primary"
                          icon={<RightOutlined />}
                          iconPosition="end"
                          onClick={() => onClick(formConfiguration)}
                        >
                          Continue
                        </Button>
                      )}
                    </>
                  ) : (
                    <Button
                      size="small"
                      type="primary"
                      icon={<RightOutlined />}
                      iconPosition="end"
                      onClick={() => onClick(formConfiguration)}
                    >
                      Activate
                    </Button>
                  )}
                </Flex>
              </Flex>
            </Card>
          )
        })}
      </Flex>
    </>
  )
}
